<div class="sdp-dashboard-container">
	<div
		fxLayout="row"
		fxLayoutAlign="start stretch"
	>
		<mat-card
			fxFlex
			class="sdp-dashboard-content"
		>
			<div class="sdp-dashboard-content-container">
				<router-outlet></router-outlet>
			</div>
		</mat-card>
	</div>
</div>